<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-2">
                </div>
                <div class="col-5">
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-9">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px" placeholder="Nhập tên danh mục..."
                                    v-model="keyword" @keyup.enter="enterKeyword()"/>
                                <div class="btn-search position-absolute">
                                    <span class="lable-search px-10px" @click="enterKeyword()">
                                        <i class="icon ion-ios-search fs-20px"></i>
                                    </span>
                                </div>
                               <!--  <div class="text-warning-search fs-10px position-absolute">
                                    * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                                </div> -->
                            </div>
                        </div>
                        <div class="col-3">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;"
                                @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>

        </div>
        <actionDialog
            :multiple="true"
            :action="action"
            :visible.sync="dialog"
            :dataMultiple="idSelect"/>
    </div>
</template>
<script>
import { upTop, availability, destroy } from '@/config/raovat';
export default {
    props: ['value', 'idSelect'],
    components: {
        actionDialog: () => import('@/components/profile/raovat/actionDialog.vue'),
    },
    data(){
        return {
            categories: [],

            data: {
            },

            keyword: this.$route.query.keyword,
            showTime: false,
            showActionMuti: false,
            fillterMobile: false,
            dialog: false,
            action: '',
            showFilterDate: false,
            loading: false,
        }
    },
    watch: {
        data:{
            handler(val){
                if(this.$detect == 'web'){
                    this.emitModel();
                }
            },
            deep: true,
        },
        value: {
            handler(val){
                this.changeValue();
            },
            deep: true,
        }
    },
    created() {
        this.changeValue();
        apiGet('/v2/profile/products/group_category').then(res => {
            this.categories = res.data;
        })
    },
    methods: {
        changeValue(){

        },
        enterKeyword(){
            if(this.keyword.length < 3 && this.keyword.length > 0) return;
            this.emitModel();
        },
        emitModel(){
            let data = {
                keyword     : this.keyword,
            }
            if(this.data.page) data.page = this.data.page;
            this.$emit('input', data)
        },
        async destroy(){
            this.loading = true;
            await destroy(this.idSelect, this);
            this.loading = false;
        },
        async availability(){
            this.loading = true;
            await availability(this.idSelect, this);
            this.loading = false;
        },
        removeFillter(){
            this.data = {}

            this.keyword = '';
            this.emitModel();
        },
    },
}
</script>
